const initialState = {
    isReadingBrandCampaigns: false,
    brand_campaigns: [],
    brand_campaigns_count: 0,
    isReadingBrand: false,
    brand: null,
    brandOptOutStatus: null,
    isReadingBrandOptOutStatus: false,
    isUpdatingBrandOptOutStatus: false,
}

export default initialState;
